module.exports = __webpack_public_path__ + "static/media/115.5a42653a.png";